import React from 'react';
import { useLanguage } from '../../LanguageContext';
import { hasPicture } from '../Utils/pictures';

/**
 * Card-opera interattiva che galleggia sulla mappa.
 * Mostra copertina (tile IIIF), datazione, luogo, descrizione breve,
 * link alla scheda e le altre opere dello stesso luogo.
 */
const MapDetailCard = ({ artwork, activeList, onClose, onSelect, onHover }) => {
  const { selectedLanguage } = useLanguage();
  const it = selectedLanguage === 'it';
  const getLangValue = (data) =>
    data ? data[it ? 'it_IT' : 'en_GB'] : '';

  if (!artwork) return null;

  const cover = (artwork.pictures || []).find(p => p.is_cover && hasPicture(p))
    || (artwork.pictures || []).find(hasPicture);

  const dateLabel = (artwork.dates || [])
    .map(d => getLangValue(d.date)
      || [d.data_inizio, d.data_fine].filter(Boolean).join(' – '))
    .filter(Boolean)
    .join(' · ');

  const place = artwork.location
    ? [artwork.location.city_town, artwork.location.name_off]
        .filter(Boolean).join(', ')
    : '';

  const others = (activeList || []).filter(a => a.id !== artwork.id);

  return (
    <div className="map-card map-card-detail">
      <button
        type="button"
        className="map-card-close"
        onClick={onClose}
        aria-label={it ? 'Chiudi' : 'Close'}
      >
        ✕
      </button>

      {cover && (
        <img
          className="map-detail-cover"
          src={`/iiif/2/${cover.id}/full/!400,300/0/default.jpg`}
          alt={getLangValue(cover.title) || getLangValue(artwork.name)}
        />
      )}

      <div className="map-detail-body">
        <h5 className="map-detail-title">{getLangValue(artwork.name)}</h5>
        {dateLabel && (
          <div className="map-detail-date">🕐 {dateLabel}</div>
        )}
        {place && (
          <div className="map-detail-place">📍 {place}</div>
        )}
        {getLangValue(artwork.short_description) && (
          <p className="map-detail-desc">
            {getLangValue(artwork.short_description)}
          </p>
        )}
        <a
          className="btn btn-sm btn-dark map-detail-link"
          href={`/artwork/${artwork.id}`}
          target="_blank"
          rel="noreferrer"
        >
          {it ? 'Approfondisci la scheda →' : 'Open full record →'}
        </a>

        {others.length > 0 && (
          <div className="map-detail-others">
            <div className="map-detail-others-title">
              {it
                ? `Nello stesso luogo (${others.length})`
                : `At the same place (${others.length})`}
            </div>
            <ul>
              {others.map((a) => (
                <li key={a.id}>
                  <button
                    type="button"
                    onClick={() => onSelect(a)}
                    onMouseEnter={() => onHover && onHover(a.id)}
                    onMouseLeave={() => onHover && onHover(null)}
                  >
                    {getLangValue(a.name)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapDetailCard;
